export const SINGLETON_INJECTABLE_TYPE: any = "root";
export const ENVIRONMENT_NAME_PROD = "Production";
export const ENVIRONMENT_NAME_UAT = "UAT";
export const ENVIRONMENT_NAME_DEV = "Development";
export const ENVIRONMENT_NAME_LOCALDEV = "Local-Development";
export const AG_GRID_EVENT_ROW_GROUP_OPENED = "rowGroupOpened";
